module.exports = __webpack_public_path__ + "topo_fispalfood_2020.png?77e3cb437cf6b75e4cb3b6ee97f6f279";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topo_fispalfood_2020.png
// module id = 169
// module chunks = 0